import { FlyoutLink } from "@app/shared/Flyouts";
import { JSX, useContext } from "react";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";
import { LicenseInfo } from "./descriptions/LicenseInfo";
import { FeatureFlagContext } from "@app/feature-flags/FeatureFlagContext";
import Features from "@app/feature-flags/features";

interface NetworkIntegrityWidgetInfoFlyoutProps {
  description: JSX.Element;
  title: string,
  showLicenseInfo?: boolean;
}

const NetworkIntegrityWidgetInfoFlyout = (props: NetworkIntegrityWidgetInfoFlyoutProps): JSX.Element => {
  const { enabledFeatureFlags } = useContext(FeatureFlagContext);
  const userGuideUrl = enabledFeatureFlags.has(Features.QES_USER_GUIDE_SFTP)
    ? "https://devstqesuserguidew.z22.web.core.windows.net/"
    : "https://questanalytics.gtmbuddy.io/shares/view/room/view/6880d01062bf7c149e2edf5c?pageId=68dd53a3c7cc1f4132f487ca#1dc0c7c667d243978a8a095d67e84ad1";
  const flyoutBody = 
    <div className="ni-widget-description">
      <h4>{props.title}</h4>
      {props.description}
      <a href={userGuideUrl} target="_blank" rel="noreferrer" data-testid="ni-widget-description__user-guide-link">For more information access our User Guide <QesIcon iconName={QesIcons.ShareV4} description="open link in a new tab" /></a>
      {props.showLicenseInfo && (
        <div className="mt-3 pt-3">
          <LicenseInfo />
        </div>
      )}
    </div>;

  return <FlyoutLink
    classNames="qes-button qes-button-secondary"
    content={{
      body: flyoutBody,
      title: 'What is this?',
    }}
    size="40"
    testId={`ni-info-panel-${props.title}`}>
    What is this?
  </FlyoutLink>;
}

export { NetworkIntegrityWidgetInfoFlyout };